"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getByName = void 0;
const next12_utils_request_1 = __importDefault(require("@gcloud-npm/next12.utils.request"));
const next12_utils_sonda_1 = __importDefault(require("@gcloud-npm/next12.utils.sonda"));
const next12_utils_build_environments_1 = require("@gcloud-npm/next12.utils.build-environments");
const next12_utils_monitoring_1 = require("@gcloud-npm/next12.utils.monitoring");
const familyApi = "custo";
const processName = "ADABYRON-API";
const getByName = ({ name, context, build = true, kind = "activity", custoParams = {}, }) => {
    const idRequest = (0, next12_utils_monitoring_1.getUUID)();
    let sonda = null;
    if (!build) {
        // importo sonda
        sonda = new next12_utils_sonda_1.default({
            eventName: "CUSTO.GET_BY_NAME",
            context,
            uniqueId: idRequest,
            origin: processName,
        });
    }
    let method2use = "GET";
    let URL_API = `/v2/customizer/standard-api/cms/get/${kind}/${name}/?${idRequest}`;
    let host = "https://qa.customizer.col.movistar.es";
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    if (currentEnv === "prod" || (build && currentEnv === "dev")) {
        host = "https://customizer.col.movistar.es";
    }
    URL_API = `${host}${URL_API}`;
    let modifiedCustoParams = {};
    if (!build) {
        let originUrl = (custoParams && custoParams.originUrl) || "";
        const windowUrl = new URL(originUrl);
        originUrl = `${windowUrl.host}${windowUrl.pathname}`;
        // console.log({originUrl});
        const queryPosition = originUrl.indexOf("?") !== -1 ? originUrl.length : originUrl.indexOf("?");
        originUrl = originUrl.substr(0, queryPosition);
        modifiedCustoParams = Object.assign(Object.assign({}, custoParams), { originUrl });
        delete modifiedCustoParams.paid;
        delete modifiedCustoParams.pageId;
        delete modifiedCustoParams.i3Ready;
        URL_API = `${URL_API}&data=${JSON.stringify(modifiedCustoParams)}`;
    }
    else {
        URL_API = `${URL_API}&skip-cache=true&data=${JSON.stringify(modifiedCustoParams)}`;
    }
    // console.log(`GET ${name}`, {URL_API});
    let headers2Use = (0, next12_utils_build_environments_1.calculateHeaderParams)(build, familyApi, context);
    headers2Use = Object.assign(Object.assign({}, headers2Use), { "Content-type": "text/plain;charset=UTF-8" });
    if (build) {
        headers2Use = Object.assign(Object.assign({}, headers2Use), { Origin: "https://www.movistar.es" });
    }
    else if (!build && method2use === "POST") {
        headers2Use = Object.assign(Object.assign({}, headers2Use), { withCredentials: true });
    }
    else if (!build && method2use === "GET") {
        headers2Use = Object.assign(Object.assign({}, headers2Use), { withCredentials: true });
    }
    // console.log({ headers2Use, name, method2use })
    const request = new next12_utils_request_1.default({
        method: method2use,
        endpoint: URL_API,
        headers: headers2Use,
        data: null,
        sonda,
    });
    return request.makeRequest();
};
exports.getByName = getByName;
exports.default = exports.getByName;
//# sourceMappingURL=index.js.map